import { useOnClickForNoResume } from "~/components/blocks/product/detail/header/video-season-header/hooks/use-on-click-for-no-resume";
import { useOnClickForResume } from "~/components/blocks/product/detail/header/video-season-header/hooks/use-on-click-for-resume";
import type { VideoSeasonType } from "~/components/blocks/product/type-guard";
import { sendTrackingClickCommon } from "~/lib/tracking/events";

type Args = {
  episodeContentId: string;
  continueWatching: VideoSeasonType["continueWatching"];
  content?: string;
  ppvProducts: VideoSeasonType["episodes"]["edges"][number]["node"]["ppvProducts"];
  svodProduct: VideoSeasonType["episodes"]["edges"][number]["node"]["svodProduct"];
  isStreamable: boolean;
  season: string;
};

export const useHandlePlayBtnPressed = (args: Args) => {
  const { episodeContentId, continueWatching, content, ppvProducts, season, svodProduct, isStreamable } = args;

  const { onClickForResume } = useOnClickForResume({
    episodeContentId,
    continueWatching,
    ppvProducts,
    svodProduct,
    content,
    season,
    isStreamable,
  });
  const { onClickForNoResume } = useOnClickForNoResume({
    episodeContentId,
    ppvProducts,
    svodProduct,
    isStreamable,
    season,
  });

  const onPlayBtnPressed = async () => {
    // videoSeason.episodes(type:MAIN)[0] が空配列の場合、何もしない
    if (episodeContentId === "") return;

    sendTrackingClickCommon({
      clickEventName: "dmmtv_button_video_play",
      viaInfo: "video_play",
      viaOption: season,
      viaTargetId: content,
    });

    // レジューム情報がある場合
    if (continueWatching !== undefined && continueWatching !== null) {
      onClickForResume();
      return;
    }
    onClickForNoResume();
    return;
  };

  return { onPlayBtnPressed };
};
